export const ROL_SUPERADMIN = 4;
export const ROL_ADMIN = 3;
export const ROL_SELLER = 2;
export const ROL_USER = 2;
// export const SERVICE_URL = 'http://localhost:6300';
export const SERVICE_URL = 'https://votacion.e-webapp.es/service';
export const ALLOW_USER_ROLES = [ROL_SUPERADMIN, ROL_ADMIN];
export const dateStart = new Date("February 26, 2022 00:00:01");
export const dateEnd = new Date("March 5, 2022 23:59:59");
